<div class="dialog-container" [ngClass]="isDesktop ? 'desktop': 'mobile'">
    <div class="title">{{selectWithdrawalName}}:</div>
    <div class="payment-list">
        <div [ngClass]="item.pk === selectedMethod?.pk ? 'active' : 'default'" class="payment" fxLayoutAlign="center" fxLayout="column" *ngFor=" let item of paymentList;" (click)="selectPayment(item)">
            <div fxLayoutAlign="space-between center" fxLayoutGap="1px" fxLayout="row">
                <div class="image"><img [src]="item.thumbnail?.url" /></div>
                <div class="info">
                    <div class="name">{{item.displayName}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
